
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cid]/[id]",
      function () {
        return require("private-next-pages/[cid]/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[cid]/[id]"])
      });
    }
  